import { CircleTickIcon, CTAButton } from '@components';
import classNames from 'classnames';
import Image from 'next/image';
import { memo } from 'react';
import { PlanCardProps } from './PlanCard.types';
import styles from './styles.module.scss';

const PlanCard = memo<PlanCardProps>(
  ({
    img,
    title,
    subtitle,
    price,
    unit,
    unitDescription,
    buttonText,
    detailSectionTitle,
    detailSections,
    isPopular,
    onCtaClick,
  }) => (
    <div
      className={classNames(styles.planCardContainer, isPopular ? styles.popular : styles.normal)}
    >
      {isPopular && <div className={classNames(styles.popularTextContainer)}>POPULAR</div>}

      <div
        className={classNames(
          styles.planCardContentContainer,
          isPopular && styles.popular,
          buttonText === 'Coming soon!' && styles.opacity,
        )}
      >
        <Image src={img} alt="plan diamond icon" className={styles.planImage} />
        <div className={styles.titleContainer}>
          <div className={styles.title}>{title}</div>
          <div className={styles.subtitle}>{subtitle}</div>
        </div>

        <div className={styles.priceContainer}>
          <div>
            <span className={styles.price}>{price}</span>
            <span className={styles.unit}>{unit}</span>
          </div>

          <div className={styles.unitDescriptionContainer}>
            {unitDescription.map((desc) => (
              <div key={desc} className={styles.unitDescription}>
                {desc}
              </div>
            ))}
          </div>
        </div>

        <CTAButton
          className={styles.button}
          variant={isPopular ? 'contained' : 'outlined'}
          onClick={onCtaClick}
          disabled={buttonText === 'Coming soon!'}
        >
          <span>{buttonText}</span>
        </CTAButton>

        <div className={styles.detailSectionContainer}>
          {detailSectionTitle && <div className={styles.title}>{detailSectionTitle}</div>}
          <div className={styles.detailSectionsContainer}>
            {detailSections.map(({ section }) => (
              <div className={styles.sectionContainer} key={section}>
                <CircleTickIcon strokeWidth={4} className={styles.tickIcon} />
                <span className={styles.section}>{section}</span>
                {/* TODO: hide icon temporarily */}
                {/* <Tooltip title={<h1>Test</h1>} enterTouchDelay={0}>
                  <span className={styles.questionIconContainer}>
                    <CircleQuestionIcon />
                  </span>
                </Tooltip> */}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  ),
);
export default PlanCard;
